module.exports = __webpack_public_path__ + "static/insurance-app-mobile-plp-7433ca70a04d4c3d478c879487ca46dd.png";